<template>
	<Container class="mx-auto">
		<div
			ref="gridContainer"
			class="sitemap-container"
		>
			<h1 class="title">Sitemap</h1>
			<div class="top-pages-container">
				<h2 class="subtitle">Top Pages</h2>
				<div class="sitemap-grid">
					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/penny-stocks/"
					>
						How to Trade Penny Stocks: Your FREE Guide
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/blog/my-secret-formula-for-finding-penny-stocks-pre-spike/"
					>
						How to Find Penny Stocks Pre-Spike (The Secret Formula)
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/blog/how-to-invest-in-penny-stocks/"
					>
						How to Invest in Penny Stocks
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/category/case-studies/"
					>
						Case Studies-Timothy Sykes Training Program
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/blog/artificial-intelligence-stocks/"
					>
						The Top 17 Artificial Intelligence Stocks to Watch
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/blog/crypto-penny-stocks/"
					>
						The Best Crypto Penny Stocks to Watch Now
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/blog/hemp-stocks/"
					>
						Top 5 Hemp Stocks to Watch
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/blog/penny-stocks-to-watch/"
					>
						Top Penny Stocks to Watch this Month
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/category/news/text-watchlists/"
					>
						Penny stocks Watch lists
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/blog/after-hours-trading/"
					>
						What Is After-Hours Trading & How Does It Work?
					</nuxt-link>
				</div>
			</div>
			<div class="blog-pages-container">
				<h2 class="subtitle">Blogs</h2>
				<div class="sitemap-grid">
					<nuxt-link
						v-for="post in posts"
						:key="post.id"
						class="sitemap-grid-link external-link"
						:to="linkDestination(post.url)"
					>
						{{ post.title }}
					</nuxt-link>
				</div>
			</div>
			<div class="others-page-container">
				<h2 class="subtitle">Others</h2>

				<div class="sitemap-grid">
					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/blog/author/tim-sykes/"
					>
						About
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="https://profit.ly/affiliate"
					>
						Affiliates
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="https://profit.ly/login"
					>
						Profitly Login
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/contact/"
					>
						Contact
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/terms-of-service/"
					>
						Terms of service
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/privacy-policy/"
					>
						Privacy policy
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/member-terms/"
					>
						Member terms
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/code-of-conduct/"
					>
						Code of conduct
					</nuxt-link>

					<nuxt-link
						class="sitemap-grid-link external-link"
						to="/millionaire-challenge/"
					>
						Millionaire Challenge
					</nuxt-link>
				</div>
			</div>
		</div>
	</Container>

	<Head>
		<Title>Sitemap - Timothy Sykes</Title>
		<Link
			rel="canonical"
			:href="`${current_hostname}${pageSlug}/`"
		/>
	</Head>
</template>
<script setup>
import { ref, onMounted, watch } from "vue";

const posts = ref([]);
const hostname = useRuntimeConfig().public.hostname;
const $route = useRoute();
const { current_hostname } = useRuntimeConfig().public;
const pageSlug = $route.name;
const perPage = 100;
const page = ref(1);
const maxPages = 10;

watch(posts, () => {
	nextTick(() => {
		forceUpdate();
	});
});

onMounted(() => {
	populatePost();
});

const linkDestination = (originalUrl) => {
	return originalUrl.replace(`${hostname}/sitemap/`, "");
};

const updatePage = async () => {
	try {
		const response = await fetch(
			`${hostname}wp-json/wp/v2/search?per_page=${perPage}&page=${page.value}&search=`
		);

		if (!response.ok) {
			throw new Error("Network response was not ok");
		}

		const data = await response.json();
		const newPosts = data.map((post) => ({
			...post,
			url: post.url.replace(
				"https://content.timothysykes.com/",
				"https://www.timothysykes.com/"
			)
		}));
		posts.value = [...posts.value, ...newPosts];
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error("Something went wrong:", error);
	}
};

const populatePost = () => {
	for (let i = 0; i <= maxPages; i++) {
		updatePage();
		++page.value;
	}
};
</script>
<style scoped>
.sitemap-container {
	padding: 80px 0px;
}
.title {
	margin-bottom: 36px;
	font-size: 32px;
	font-weight: 600;
	font-family: Rubik;
	display: block;
	font-weight: bold;
	color: #292b2c;
}

.subtitle {
	line-height: 1;
	font-size: 24px;
	padding-bottom: 27px;
	font-family: Rubik;
	display: block;
	font-weight: lighter;
	color: #292b2c;
}

.top-pages-container,
.blog-pages-container,
.others-page-container {
	display: grid;
	grid-template-columns: 270px auto;
	align-items: flex-start;
	margin-bottom: 52px;
}

.sitemap-grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-column-gap: 24px;
	grid-row-gap: 32px;
	line-height: 1.2;
}

.sitemap-grid-link {
	margin-right: 12px;
	font-size: 18px;
	font-family: Helvetica;
	color: #3fa9f5;
	white-space: nowrap;
	margin-right: 0;
	padding: 0;
	white-space: normal;
	word-wrap: break-word;
}

@media (max-width: 992px) {
	.top-pages-container,
	.blog-pages-container,
	.others-page-container {
		grid-template-columns: 1fr;
	}

	.sitemap-grid {
		grid-template-columns: 1fr;
		grid-column-gap: 0;
		grid-row-gap: 16px;
	}

	.sitemap-grid-link {
		font-size: 16px;
	}
}
</style>
